import { api as apiProvider } from '@/core/api/';

const baseApiURL = 'api/servicebudget';

export const getBudgetsAcademicYears = () =>
  apiProvider.get(`${baseApiURL}/academicyears`);
export const saveServiceBudget = async (model) =>
  apiProvider.post(`${baseApiURL}/save`, model);
export const getBudgetsByAcademicYearId = (academicYearId) =>
  apiProvider.get(`${baseApiURL}/searchbudgetbyacademicyear/${academicYearId}`);
export const getBudgetDetails = (academicYearId) =>
  apiProvider.get(`${baseApiURL}/searchbudgetdetails/${academicYearId}`);
